import SVGImage from './SVGImage.vue';

export default SVGImage;
